import { type PropsWithChildren, type ReactElement } from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

export function Tooltip({
    children,
    content,
    delayDuration,
    align = "center",
    side,
    sideOffset,
}: PropsWithChildren & {
    content?: string | ReactElement;
    delayDuration?: number;
    align?: "center" | "start" | "end";
    side?: "top" | "right" | "bottom" | "left";
    sideOffset?: number;
}) {
    return (
        <TooltipPrimitive.Provider delayDuration={delayDuration || 500}>
            <TooltipPrimitive.Root>
                <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
                {content && (
                    <TooltipPrimitive.Content
                        side={side}
                        align={align}
                        sideOffset={sideOffset}
                        className="z-50 m-4 rounded-md bg-surface-invert px-3 py-2 text-sm text-content-invert"
                        hideWhenDetached={true}
                    >
                        {content}
                    </TooltipPrimitive.Content>
                )}
            </TooltipPrimitive.Root>
        </TooltipPrimitive.Provider>
    );
}
